"use client"

import { PickerView, Popup } from "antd-mobile"
import { PickerColumn, PickerValue } from "antd-mobile/es/components/picker-view"
import { useEffect, useMemo, useRef, useState } from "react"

import Style from "./index.module.scss"

type IProps<T = number | string> = {
	visible: boolean
	columns: PickerColumn[]
	onClose: () => void
	onConfirm: (value: T[]) => void
	defaultValue?: T[]
}
const SelectPicker = <T extends number | string = number | string>({
	visible,
	onClose,
	columns,
	onConfirm,
	defaultValue,
}: IProps<T>) => {
	const keyCounterRef = useRef(0)
	const initialValue = useMemo(() => defaultValue ?? [], [defaultValue])

	// 存储用户选择的值
	const [userSelectedValue, setUserSelectedValue] = useState<T[]>([])

	// key，重置 PickerView 组件
	const [pickerKey, setPickerKey] = useState("picker-0")

	// 当前显示的值
	const currentValue = useMemo(() => {
		return userSelectedValue.length > 0 ? userSelectedValue : initialValue
	}, [initialValue, userSelectedValue])

	// 更新PickerView 并重置选择
	useEffect(() => {
		if (visible) {
			keyCounterRef.current += 1
			setPickerKey(`picker-${keyCounterRef.current}`)
			setUserSelectedValue([])
		}
	}, [visible])

	return (
		<Popup
			visible={visible}
			onMaskClick={() => {
				onClose()
			}}
			bodyStyle={{
				height: "300px",
				borderTopLeftRadius: "16px",
				borderTopRightRadius: "16px",
			}}
			getContainer={null}
			bodyClassName={Style.popupBody}
		>
			<div className={Style.popupHeader}>
				<span onClick={onClose}>Cancel</span>
				<span
					onClick={() => {
						onConfirm(currentValue)
					}}
				>
					Save
				</span>
			</div>
			<PickerView
				key={pickerKey}
				mouseWheel
				columns={columns as PickerColumn[]}
				value={currentValue as PickerValue[]}
				onChange={(v: PickerValue[]) => {
					setUserSelectedValue(v as T[])
				}}
			/>
		</Popup>
	)
}

export default SelectPicker
